//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-faq-accordion',
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    getIcon() {
      return this.isOpen ? 'minus-dark-straight' : 'plus-dark-straight'
    },
  },
  methods: {
    setIsOpen(isOpen) {
      this.isOpen = isOpen
    },
  },
}
